module.exports = __webpack_public_path__ + "static/img/3.27626990.png";